import React from 'react';
import CustomHelmet from 'components/CustomHelmet';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { selectLocale } from 'models/localization';
import { selectLocalizedEventName } from 'models/virtual_event';
import ProductList from './components/ProductList';

const PageContainer = styled.div`
  width: 100%;
  height: 100%;
  background-attachment: fixed;
  background-color: #F0F2F5;
  position: relative;
`;

const RootContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  overflow: auto;
`;

const ProductPage = () => {
  const { t } = useTranslation();
  const locale = useSelector(selectLocale);
  const { pageNames: { products } } = useSelector((state: any) => state.eventConfigs);
  const eventName = useSelector(selectLocalizedEventName);
  const pageTitle = products?.[locale] || t('page.products', 'Products');

  return (
    <>
      <CustomHelmet>
        <meta charSet="utf-8" />
        <title>{`${pageTitle} | ${eventName}`}</title>
        <meta name="description" content={`${pageTitle} page of ${eventName}.`} />
      </CustomHelmet>
      <PageContainer>
        <RootContainer>
          <ProductList />
        </RootContainer>
      </PageContainer>
    </>
  );
};

export default ProductPage;
